module.exports = __webpack_public_path__ + "img/name.4f0e35ee.png";